import AboutHeader from './components/AboutHeader';
import AboutHero from './components/AboutHero';
import CoreCognition from './components/CoreCognition';
import TechArchitecture from './components/TechArchitecture';
import AICapability from './components/AICapability';
import Ecosystem from './components/Ecosystem';
import Security from './components/Security';
import Vision from './components/Vision';
import AboutCTA from './components/AboutCTA';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <AboutHeader />
      <AboutHero />
      <CoreCognition />
      <TechArchitecture />
      <AICapability />
      <Ecosystem />
      <Security />
      <Vision />
      <AboutCTA />
    </div>
  );
}